/*
 * 人人都是产品经理 - 热榜（服务端路由）
 */
export async function fetchWoshipmHot() {
  const res = await fetch('/server-api/woshipm')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
